import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const AfterPayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.AFTERPAY}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.AFTERPAY)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.AFTERPAY)} alt="afterpay" />
    </Box>
  );
};
